import React from 'react';

export function UnknownStatusIcon(props: {
  kind: 'hvac' | 'fan';
  label: string;
}): JSX.Element {
  return (
    <svg
      viewBox="0 0 32 32"
      width="26"
      height="26"
      role="img"
      aria-label={props.label}
      className="unknown-status-icon"
    >
      {props.kind === 'hvac' ? (
        <rect x="5" y="3" width="22" height="26" rx="5" />
      ) : (
        <>
          <circle cx="16" cy="16" r="13" />
          <path d="M16 4v8M28 16h-8M16 28v-8M4 16h8" />
        </>
      )}
      <circle cx="16" cy="16" r="8" />
      <text x="16" y="21" textAnchor="middle">
        ?
      </text>
    </svg>
  );
}
